webpackJsonp([595],{

/***/ 1048:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2002:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1048),
  /* template */
  __webpack_require__(2985),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/changes-43.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] changes-43.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b2d7855e", Component.options)
  } else {
    hotAPI.reload("data-v-b2d7855e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2985:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("next (not release yet)_COM")]), _vm._v(" "), _c('h4', [_vm._v("Sticky")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  scroll-box 不存在时在开发模式下进行提示")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.8.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 justify 类名 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2545",
      "target": "_blank"
    }
  }, [_vm._v("#2545")])])])]), _vm._v(" "), _c('h4', [_vm._v("Grid")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:show-lr-borders、prop:show-vertical-dividers 用以隐藏左右边线及垂直分割线 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2488",
      "target": "_blank"
    }
  }, [_vm._v("#2488")])])])]), _vm._v(" "), _c('h4', [_vm._v("Previewer")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持事件 on-index-change "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2505",
      "target": "_blank"
    }
  }, [_vm._v("#2505")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持滚动")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:right-full-height 用于方便显示验证码图片 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2475",
      "target": "_blank"
    }
  }, [_vm._v("#2475")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复单独插件引用时无样式 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2375",
      "target": "_blank"
    }
  }, [_vm._v("#2375")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.8.0_COM")]), _vm._v(" "), _c('h4', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复输入框难以移动光标")])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  去除空的根节点 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2371",
      "target": "_blank"
    }
  }, [_vm._v("#2371")])])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复初始值为0时不显示清除按钮问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2482",
      "target": "_blank"
    }
  }, [_vm._v("#2482")])])])]), _vm._v(" "), _c('h4', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复初始化时 on-change 错误触发")])])]), _vm._v(" "), _c('h4', [_vm._v("XTextarea")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 disabled "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2522",
      "target": "_blank"
    }
  }, [_vm._v("#2522")])])])]), _vm._v(" "), _c('h4', [_vm._v("Cookie")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  change to es6 module style")])])]), _vm._v(" "), _c('h4', [_vm._v("Date")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  change to es6 module style")])])]), _vm._v(" "), _c('h4', [_vm._v("Number")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  change to es6 module style")])])]), _vm._v(" "), _c('h4', [_vm._v("Wechat")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  更新到 1.3.2 版本 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2396",
      "target": "_blank"
    }
  }, [_vm._v("#2396")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.7.9_COM")]), _vm._v(" "), _c('h4', [_vm._v("Clocker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复更新值为非空时报错问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2449",
      "target": "_blank"
    }
  }, [_vm._v("#2449")])])])]), _vm._v(" "), _c('h4', [_vm._v("Panel")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  footer.title 为空时隐藏 footer "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2476",
      "target": "_blank"
    }
  }, [_vm._v("#2476")])])])]), _vm._v(" "), _c('h4', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修正 itemClass 拼写错误 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2457",
      "target": "_blank"
    }
  }, [_vm._v("#2457")])])])]), _vm._v(" "), _c('h4', [_vm._v("Rater")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  prop:min 增加最小值 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2439",
      "target": "_blank"
    }
  }, [_vm._v("#2439")])])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持中国联通手机号166号段")])])]), _vm._v(" "), _c('h4', [_vm._v("Bus")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  bus 挂载到 this.$vux")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.7.8_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 `on-hide` 事件触发两次的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2379",
      "target": "_blank"
    }
  }, [_vm._v("#2379")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复初始化时 `show` 值为 `true` 无效的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复多级联动模式下，子代没有数据时，取值不正确。")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 popup-radio 组件不支持cell组件中 border-intent 的属性。")])])]), _vm._v(" "), _c('h4', [_vm._v("Wechat")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  使用 1.3.0 版本，废弃依赖 weixin-js-sdk")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.7.7_COM")]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  去除第一个子元素的上边线 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2371",
      "target": "_blank"
    }
  }, [_vm._v("#2371")])])])]), _vm._v(" "), _c('h4', [_vm._v("Sticky")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复定位不准确和定位无效的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2367",
      "target": "_blank"
    }
  }, [_vm._v("#2367")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复只有一个 item 时无法滚动页面的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Tabbar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 tabbar-item 服务端渲染不一致问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  插件 options 参数作为toast的默认参数")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复报错信息不会改变的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2348",
      "target": "_blank"
    }
  }, [_vm._v("#2348")])])])]), _vm._v(" "), _c('h3', [_vm._v("2.7.6_COM")]), _vm._v(" "), _c('h4', [_vm._v("ButtonTab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复分割线会消失的bug "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2322",
      "target": "_blank"
    }
  }, [_vm._v("#2322")])])])]), _vm._v(" "), _c('h4', [_vm._v("Calendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复选中同个日期时无法自动关闭的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2306",
      "target": "_blank"
    }
  }, [_vm._v("#2306")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  列的值使用number类型，修正绑定值与datetimepicker值不相等 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2296",
      "target": "_blank"
    }
  }, [_vm._v("#2296")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加事件 on-select-single-date")])])]), _vm._v(" "), _c('h4', [_vm._v("LoadMore")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  不再需要设置 `background-color`")])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 在 cancel 或 clear 时没有触发 on-change 和 input 事件")])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  只有一张图片时阻止滑动跟随")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加disabled样式 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2279",
      "target": "_blank"
    }
  }, [_vm._v("#2279")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.7.5_COM")]), _vm._v(" "), _c('h4', [_vm._v("Clocker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 beforeDestroy 调用时 this.clocker 不存在 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2258",
      "target": "_blank"
    }
  }, [_vm._v("#2258")])])])]), _vm._v(" "), _c('h4', [_vm._v("Panel")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  移除重复顶部边框样式")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:header slot:body "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2270",
      "target": "_blank"
    }
  }, [_vm._v("#2270")])])])]), _vm._v(" "), _c('h4', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复plain样式并禁用时class不对的问题")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.7.4_COM")]), _vm._v(" "), _c('h4', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复值为 0 时事件参数为空的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2209",
      "target": "_blank"
    }
  }, [_vm._v("#2209")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持事件 on-confirm on-cancel "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2221",
      "target": "_blank"
    }
  }, [_vm._v("#2221")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tabbar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  开发模式下对于非 100% 布局使用显示 absolute 定位说明")])])]), _vm._v(" "), _c('h4', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  顺应 iOS 设计，支持直接定义背景渐变 prop:gradients")])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复定位为 absolute 导致的定位问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2220",
      "target": "_blank"
    }
  }, [_vm._v("#2220")])])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复服务端渲染 DOM 不一致问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2201",
      "target": "_blank"
    }
  }, [_vm._v("#2201")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.7.3_COM")]), _vm._v(" "), _c('h4', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复输入框难以获取 focus 的问题（感谢 "), _c('a', {
    attrs: {
      "href": "https://github.com/Sapphire2k",
      "target": "_blank"
    }
  }, [_vm._v("@Sapphire2k")]), _vm._v("）")])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 disable-date-function 取值与禁用周末逻辑冲突 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2189",
      "target": "_blank"
    }
  }, [_vm._v("#2189")])])])]), _vm._v(" "), _c('h4', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  渲染出错时提示是否联动数据忘了指定列数")])])]), _vm._v(" "), _c('h4', [_vm._v("Rater")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  prop:star 支持 html "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2182",
      "target": "_blank"
    }
  }, [_vm._v("#2182")])])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复输入法导致 on-change 事件提前触发")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.7.2_COM")]), _vm._v(" "), _c('h4', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持作为模块直接调用 (import { AlertModule } from 'vux') "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2173",
      "target": "_blank"
    }
  }, [_vm._v("#2173")])])])]), _vm._v(" "), _c('h4', [_vm._v("Calendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持禁用选择属性 prop:readonly "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2178",
      "target": "_blank"
    }
  }, [_vm._v("#2178")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 on-change 事件重复触发的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  当指定结束日期但未指定开始日期时使用默认年第一天作为开始日期 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2158",
      "target": "_blank"
    }
  }, [_vm._v("#2158")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复多选情况下重置值时没有正确渲染的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2160",
      "target": "_blank"
    }
  }, [_vm._v("#2160")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复部分属性没有继承 inline-calendar 的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2105",
      "target": "_blank"
    }
  }, [_vm._v("#2105")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复禁用周末日期仍能点击的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2178",
      "target": "_blank"
    }
  }, [_vm._v("#2178")])])])]), _vm._v(" "), _c('h4', [_vm._v("Selector")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 value-map 属性用以自动转换 API 数据 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2139",
      "target": "_blank"
    }
  }, [_vm._v("#2139")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 getFullValue 方法获取当中选中值的原始数据")])])]), _vm._v(" "), _c('h4', [_vm._v("Tab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持阻止自动切换 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2176",
      "target": "_blank"
    }
  }, [_vm._v("#2176")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.7.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复插件使用时 less 变量不生效问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2152",
      "target": "_blank"
    }
  }, [_vm._v("#2152")])])])]), _vm._v(" "), _c('h4', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  链接支持对象类型 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2068",
      "target": "_blank"
    }
  }, [_vm._v("#2068")])])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 prevent-body-scroll.css 无法找到问题(less-loader) "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2118",
      "target": "_blank"
    }
  }, [_vm._v("#2118")])])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复数字为 0 时 valid 为 false 的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2134",
      "target": "_blank"
    }
  }, [_vm._v("#2134")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 on-blur 事件没有正确触发的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2146",
      "target": "_blank"
    }
  }, [_vm._v("#2146")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.7.0_COM")]), _vm._v(" "), _c('h4', [_vm._v("Calendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复上边框 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2104",
      "target": "_blank"
    }
  }, [_vm._v("#2104")])])])]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 ssr 渲染问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复默认选中项缺失问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2122",
      "target": "_blank"
    }
  }, [_vm._v("#2122")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复服务端渲染多语言 bug")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 readonly 为 true 时点击还会显示弹窗的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2079",
      "target": "_blank"
    }
  }, [_vm._v("#2079")])])])]), _vm._v(" "), _c('h4', [_vm._v("Flow")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  为 flow-state 添加 slot:title "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2010",
      "target": "_blank"
    }
  }, [_vm._v("#2010")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  在 created hook 执行渲染而不是 mounted(ssr)")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 prop:disable-weekend 来禁用周末 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2105",
      "target": "_blank"
    }
  }, [_vm._v("#2105")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 prop:disable-date-function 自定义标记禁用日期 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2105",
      "target": "_blank"
    }
  }, [_vm._v("#2105")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  移除重复的多次重复渲染 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2066",
      "target": "_blank"
    }
  }, [_vm._v("#2066")])])])]), _vm._v(" "), _c('h4', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  picker 移动距离不再遵从 html[data-dpr")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加属性 popup-title(使用 popup-header 组件) "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1866",
      "target": "_blank"
    }
  }, [_vm._v("#1866")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  兼容 vue"), _c('a', {
    attrs: {
      "href": "https://github.com/2",
      "target": "_blank"
    }
  }, [_vm._v("@2")]), _vm._v(".5.0 scope 更名为 slot-scope 的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2076",
      "target": "_blank"
    }
  }, [_vm._v("#2076")])])])]), _vm._v(" "), _c('h4', [_vm._v("Qrcode")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 value 为 undefined 时报错的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2070",
      "target": "_blank"
    }
  }, [_vm._v("#2070")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  使用 style 样式设置宽高 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2075",
      "target": "_blank"
    }
  }, [_vm._v("#2075")])])])]), _vm._v(" "), _c('h4', [_vm._v("Selector")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  兼容服务端渲染")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复值为 null 时 placeholder 没有显示的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2101",
      "target": "_blank"
    }
  }, [_vm._v("#2101")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  非循环模式下对第一张和最后一张使用更短的拖动距离")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加事件 event:on-get-height "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2112",
      "target": "_blank"
    }
  }, [_vm._v("#2112")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  auto 支持动态设置 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2027",
      "target": "_blank"
    }
  }, [_vm._v("#2027")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  兼容 vue"), _c('a', {
    attrs: {
      "href": "https://github.com/2",
      "target": "_blank"
    }
  }, [_vm._v("@2")]), _vm._v(".5.0 scope 更名为 slot-scope 的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2076",
      "target": "_blank"
    }
  }, [_vm._v("#2076")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加属性 popup-title(使用 popup-header 组件) "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1866",
      "target": "_blank"
    }
  }, [_vm._v("#1866")])])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加事件 on-click-mask "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2102",
      "target": "_blank"
    }
  }, [_vm._v("#2102")])])])]), _vm._v(" "), _c('h4', [_vm._v("XSwitch")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:value-map 自定义值映射，比如 [0, 1")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.6.5_COM")]), _vm._v(" "), _c('h4', [_vm._v("CellBox")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 align-items")])])]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复仅调用 checklist 组件时图标样式不存在 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2041",
      "target": "_blank"
    }
  }, [_vm._v("#2041")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  在created时，初始化tempValue值 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2059",
      "target": "_blank"
    }
  }, [_vm._v("#2059")])])])]), _vm._v(" "), _c('h4', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  修复快速点击按钮时触发多次的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2048",
      "target": "_blank"
    }
  }, [_vm._v("#2048")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持事件 on-show on-hide "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2053",
      "target": "_blank"
    }
  }, [_vm._v("#2053")])])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  兼容同时使用 is-type:china-mobile 和 mask 的情况 "), _c('a', {
    attrs: {
      "href": "https://github.com/2040",
      "target": "_blank"
    }
  }, [_vm._v("@2040")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.6.4_COM")]), _vm._v(" "), _c('h4', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持属性 mask-z-index 设置遮罩 z-index")])])]), _vm._v(" "), _c('h4', [_vm._v("Calendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持格式化值显示 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2023",
      "target": "_blank"
    }
  }, [_vm._v("#2023")])])])]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持属性 align-items")])])]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加方法 getFullValue 获取值和对应的显示文字 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2022",
      "target": "_blank"
    }
  }, [_vm._v("#2022")])])])]), _vm._v(" "), _c('h4', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持属性 mask-z-index 设置遮罩 z-index")])])]), _vm._v(" "), _c('h4', [_vm._v("Previewer")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  方便删除操作，绑定数据减少一张时自动更新示图，有更多图片时切换到下一张，没有时将自动关闭预览")])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持属性 mask-z-index 设置遮罩 z-index")])])]), _vm._v(" "), _c('h4', [_vm._v("CloseDialogs")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新插件，用于在路由切换时自动关闭所有 plugin 形式打开的弹窗，包括 alert confirm toast loading datetime "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2025",
      "target": "_blank"
    }
  }, [_vm._v("#2025")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.6.3_COM")]), _vm._v(" "), _c('h4', [_vm._v("Checker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持属性 radio-required 强制单选模式下必选一项 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2004",
      "target": "_blank"
    }
  }, [_vm._v("#2004")])])])]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  on-change 参数支持 labels "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2018",
      "target": "_blank"
    }
  }, [_vm._v("#2018")])])])]), _vm._v(" "), _c('h4', [_vm._v("Previewer")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复组件函数名字以下划线开头将会被 Vue(2.4.4) 警告的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2001",
      "target": "_blank"
    }
  }, [_vm._v("#2001")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 getCurrentIndex 方法")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:button-before 和 slot:button-after")])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加事件 on-blur")])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 type 为 text 时使用 slot 缺失 padding 样式的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  点击错误图标时显示错误内容 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2009",
      "target": "_blank"
    }
  }, [_vm._v("#2009")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.6.2_COM")]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 max=1 交互为单选模式 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1996",
      "target": "_blank"
    }
  }, [_vm._v("#1996")])])])]), _vm._v(" "), _c('h4', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  滚动距离支持从 html[data-dpr")])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  更新地址数据 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2000",
      "target": "_blank"
    }
  }, [_vm._v("#2000")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.6.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持属性 compute-days-function 用以动态设置日期 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1992",
      "target": "_blank"
    }
  }, [_vm._v("#1992")])])])]), _vm._v(" "), _c('h4', [_vm._v("Grid")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 `cols` 属性，自定义列数")])])]), _vm._v(" "), _c('h4', [_vm._v("Scroller")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  在`updated` 钩子中调用`reset`")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  为 label 设置 for 属性 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1983",
      "target": "_blank"
    }
  }, [_vm._v("#1983")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持属性 mask 对输入值进行格式化")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.6.0_COM")]), _vm._v(" "), _c('h4', [_vm._v("Calendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持显示弹窗头部(取消，确定)")])])]), _vm._v(" "), _c('h4', [_vm._v("Checker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 on-change 事件 在使用 :value 绑定的情况下不触发 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1945",
      "target": "_blank"
    }
  }, [_vm._v("#1945")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复取消文字、确认文字国际化显示问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Grid")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  rows 属性已经废弃，使用自动计算 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1971",
      "target": "_blank"
    }
  }, [_vm._v("#1971")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  (beta) 支持属性 marks 用以自定义特定日期显示样式")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复星期文字 i18n")])])]), _vm._v(" "), _c('h4', [_vm._v("LoadMore")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 `tip` 为空，且 `show-loading` 为 `false` 时背景颜色不对的问题 ")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 "), _c('a', {
    attrs: {
      "href": "https://github.com/load",
      "target": "_blank"
    }
  }, [_vm._v("@load")]), _vm._v("-more-tip-background-color 全局设置文字背景颜色")])])]), _vm._v(" "), _c('h4', [_vm._v("Panel")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持列表 fallbackSrc 属性在图片加载失败后显示 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1923",
      "target": "_blank"
    }
  }, [_vm._v("#1923")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 placeholder 显示逻辑 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1964",
      "target": "_blank"
    }
  }, [_vm._v("#1964")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持 list.fallbackImg 属性在图片加载失败时显示预设图片 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1923",
      "target": "_blank"
    }
  }, [_vm._v("#1923")])])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复弹窗滑动时 body 区域依然会滚动的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("XImg")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  当 src 变化时重新初始化 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1901",
      "target": "_blank"
    }
  }, [_vm._v("#1901")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.12_COM")]), _vm._v(" "), _c('h4', [_vm._v("FormPreview")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 header-value 为空时的错位问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1935",
      "target": "_blank"
    }
  }, [_vm._v("#1935")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 switchViewToToday, switchViewToMonth 等手动渲染方法")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持事件 on-view-change，方便切换月份时请求数据")])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  在 beforeDestroy 和 deactivated 事件中清除设置于 body 上的 vux-modal-open 类名 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1921",
      "target": "_blank"
    }
  }, [_vm._v("#1921")])])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  属性 scroll 已经废弃，仅对配置为 100% 布局的情况实现阻止滚动 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1858",
      "target": "_blank"
    }
  }, [_vm._v("#1858")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1877",
      "target": "_blank"
    }
  }, [_vm._v("#1877")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复多次调用重复显示的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1927",
      "target": "_blank"
    }
  }, [_vm._v("#1927")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.11_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 :show.sync 设为 false 无效 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1918",
      "target": "_blank"
    }
  }, [_vm._v("#1918")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复特定情况下月份变化不会触发小时重新渲染的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持方法 getDates 用于需要获取渲染日期列表的场合")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 less 变量 "), _c('a', {
    attrs: {
      "href": "https://github.com/calendar",
      "target": "_blank"
    }
  }, [_vm._v("@calendar")]), _vm._v("-bg-color")])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  仅在全局配置 $layout = VIEW_BOX 时用 fixed body 的形式阻止页面滚动 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1893",
      "target": "_blank"
    }
  }, [_vm._v("#1893")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.10_COM")]), _vm._v(" "), _c('h4', [_vm._v("Calendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:placeholder")])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  值文字颜色受控于 "), _c('a', {
    attrs: {
      "href": "https://github.com/cell",
      "target": "_blank"
    }
  }, [_vm._v("@cell")]), _vm._v("-value-color "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1874",
      "target": "_blank"
    }
  }, [_vm._v("#1874")])])])]), _vm._v(" "), _c('h4', [_vm._v("Marquee")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:item-height "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1885",
      "target": "_blank"
    }
  }, [_vm._v("#1885")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  值文字颜色受控于 "), _c('a', {
    attrs: {
      "href": "https://github.com/cell",
      "target": "_blank"
    }
  }, [_vm._v("@cell")]), _vm._v("-value-color "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1874",
      "target": "_blank"
    }
  }, [_vm._v("#1874")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  值文字颜色受控于 "), _c('a', {
    attrs: {
      "href": "https://github.com/cell",
      "target": "_blank"
    }
  }, [_vm._v("@cell")]), _vm._v("-value-color "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1874",
      "target": "_blank"
    }
  }, [_vm._v("#1874")])])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 class 工具函数拼写错误 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1893",
      "target": "_blank"
    }
  }, [_vm._v("#1893")])])])]), _vm._v(" "), _c('h4', [_vm._v("Previewer")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持 goTo 方法 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1888",
      "target": "_blank"
    }
  }, [_vm._v("#1888")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.9_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复格式为 YYYY 时的报错 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1861",
      "target": "_blank"
    }
  }, [_vm._v("#1861")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  点击当前日期项时不把值置为空 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1862",
      "target": "_blank"
    }
  }, [_vm._v("#1862")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupHeader")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复错误的 slot 名字")])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  修复当body没有设置100%宽度时出现的布局错乱问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1867",
      "target": "_blank"
    }
  }, [_vm._v("#1867")])])])]), _vm._v(" "), _c('h4', [_vm._v("Sticky")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 scrollTop 总是返回0的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1827",
      "target": "_blank"
    }
  }, [_vm._v("#1827")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  prop:show 支持.sync修饰")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.8_COM")]), _vm._v(" "), _c('h4', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  插件支持 setInputValue 方法 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1846",
      "target": "_blank"
    }
  }, [_vm._v("#1846")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 on-change 事件触发两次问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1847",
      "target": "_blank"
    }
  }, [_vm._v("#1847")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  popup显示时阻止背景滚动 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1830",
      "target": "_blank"
    }
  }, [_vm._v("#1830")])])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  zIndex 值应该比 XDialog 大 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1820",
      "target": "_blank"
    }
  }, [_vm._v("#1820")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新增 prop:show 控制是否显示")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.7_COM")]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持在 on-change 事件中附带 `label` 值 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1783",
      "target": "_blank"
    }
  }, [_vm._v("#1783")])])])]), _vm._v(" "), _c('h4', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:input-attrs 设置额外属性 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1799",
      "target": "_blank"
    }
  }, [_vm._v("#1799")])])])]), _vm._v(" "), _c('h4', [_vm._v("Loading")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 vue"), _c('a', {
    attrs: {
      "href": "https://github.com/2",
      "target": "_blank"
    }
  }, [_vm._v("@2")]), _vm._v(".4 no setter 警告，可以直接用 :show 绑定 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1798",
      "target": "_blank"
    }
  }, [_vm._v("#1798")])])])]), _vm._v(" "), _c('h4', [_vm._v("Panel")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  属性使用 v-html 绑定 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1784",
      "target": "_blank"
    }
  }, [_vm._v("#1784")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复修改值后第二次打开默认选中项渲染不正确的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1793",
      "target": "_blank"
    }
  }, [_vm._v("#1793")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.6_COM")]), _vm._v(" "), _c('h4', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复取消菜单上的 json 解析错误 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1782",
      "target": "_blank"
    }
  }, [_vm._v("#1782")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持在滑动 picker 时触发事件 on-shadow-change "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1778",
      "target": "_blank"
    }
  }, [_vm._v("#1778")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持在滑动 picker 时触发事件 on-shadow-change "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1778",
      "target": "_blank"
    }
  }, [_vm._v("#1778")])])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 is-type 验证逻辑 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1776",
      "target": "_blank"
    }
  }, [_vm._v("#1776")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.5_COM")]), _vm._v(" "), _c('h4', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持在 on-click-menu 参数里附带原始 menu 对象 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1772",
      "target": "_blank"
    }
  }, [_vm._v("#1772")])])])]), _vm._v(" "), _c('h4', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 hideOnBlur "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1742",
      "target": "_blank"
    }
  }, [_vm._v("#1742")])])])]), _vm._v(" "), _c('h4', [_vm._v("CellBox")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  移除默认 slot 的父级 div "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1769",
      "target": "_blank"
    }
  }, [_vm._v("#1769")])])])]), _vm._v(" "), _c('h4', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持方法 setInputValue 设置输入值 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1746",
      "target": "_blank"
    }
  }, [_vm._v("#1746")])])])]), _vm._v(" "), _c('h4', [_vm._v("Countup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 tag 用以定义渲染标签 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1739",
      "target": "_blank"
    }
  }, [_vm._v("#1739")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持动态设置小时列表 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1749",
      "target": "_blank"
    }
  }, [_vm._v("#1749")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  更加流畅的遮罩层动画")])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持多选 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1446",
      "target": "_blank"
    }
  }, [_vm._v("#1446")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1467",
      "target": "_blank"
    }
  }, [_vm._v("#1467")])])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  在 deactived 事件触发时自动关闭，避免在路由切换时依然显示弹窗，可以使用 prop:hide-on-deactivated 进行禁用 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1774",
      "target": "_blank"
    }
  }, [_vm._v("#1774")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  swipeout-item 新增 render 方法 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1688",
      "target": "_blank"
    }
  }, [_vm._v("#1688")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tabbar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 link 上使用 replace: true 写法 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1761",
      "target": "_blank"
    }
  }, [_vm._v("#1761")])])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  为 on-focus on-blur 事件添加 $event 参数 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1770",
      "target": "_blank"
    }
  }, [_vm._v("#1770")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复值为空的错误判断逻辑 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1759",
      "target": "_blank"
    }
  }, [_vm._v("#1759")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.4_COM")]), _vm._v(" "), _c('h4', [_vm._v("Group")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  XSwitch的labelAlign 支持 justify "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1707",
      "target": "_blank"
    }
  }, [_vm._v("#1707")])])])]), _vm._v(" "), _c('h4', [_vm._v("Sticky")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  在 router-view 动画结束后自动重新绑定")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复在ios上fixed不生效的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1657",
      "target": "_blank"
    }
  }, [_vm._v("#1657")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tabbar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加事件 on-index-change "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1715",
      "target": "_blank"
    }
  }, [_vm._v("#1715")])])])]), _vm._v(" "), _c('h4', [_vm._v("XImg")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  在 router-view 动画结束后自动重新监听加载")])])]), _vm._v(" "), _c('h4', [_vm._v("Bus")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新插件，用于 vux 组件全局事件管理")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.3_COM")]), _vm._v(" "), _c('h4', [_vm._v("Group")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  labelAlign 支持 justify "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1574",
      "target": "_blank"
    }
  }, [_vm._v("#1574")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复在 x-textarea 后引入 popup-picker label 宽度被覆盖 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1696",
      "target": "_blank"
    }
  }, [_vm._v("#1696")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  轮播个数不为2时清除 listTtwoLoopItem 列表 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1684",
      "target": "_blank"
    }
  }, [_vm._v("#1684")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/weizs",
      "target": "_blank"
    }
  }, [_vm._v("@weizs")])])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新增 prop:show 并且支持.sync修饰符")])])]), _vm._v(" "), _c('h4', [_vm._v("XHeader")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:overwrite-title "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1669",
      "target": "_blank"
    }
  }, [_vm._v("#1669")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.2_COM")]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  在 `on-change` 事件之前 emit `input` 事件")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  `options` 中增加 `inlineDesc` 属性")])])]), _vm._v(" "), _c('h4', [_vm._v("InlineXNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  单独的 inline-x-number 组件可以正常使用了")])])]), _vm._v(" "), _c('h4', [_vm._v("Panel")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加type类型(4,5)和描述信息(来源,时间和其他自定义信息)")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupHeader")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件 popup-header, 配合 popup 使用统一头部样式")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持弹窗样式设置 prop:popup-style "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1656",
      "target": "_blank"
    }
  }, [_vm._v("#1656")])])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持弹窗样式设置 prop:popup-style "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1656",
      "target": "_blank"
    }
  }, [_vm._v("#1656")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持弹窗样式设置 prop:popup-style "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1656",
      "target": "_blank"
    }
  }, [_vm._v("#1656")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("Group")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:title "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1650",
      "target": "_blank"
    }
  }, [_vm._v("#1650")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 array-from 在 webpack"), _c('a', {
    attrs: {
      "href": "https://github.com/3",
      "target": "_blank"
    }
  }, [_vm._v("@3 ")]), _vm._v("下报错问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1649",
      "target": "_blank"
    }
  }, [_vm._v("#1649")])])])]), _vm._v(" "), _c('h4', [_vm._v("XTextarea")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加方法 updateAutosize 在存在默认值的情况下手动重置高度")])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复插件形式使用时缺失样式导致报错问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1659",
      "target": "_blank"
    }
  }, [_vm._v("#1659")])])])]), _vm._v(" "), _c('h4', [_vm._v("TransferDom")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  默认不在组件内容更新时自动重新渲染，修复 popup-picker 关闭闪现体验问题")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.5.0_COM")]), _vm._v(" "), _c('h4', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:close-on-confirm")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:show-input")])])]), _vm._v(" "), _c('h4', [_vm._v("DatetimeView")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件 DatetimeView")])])]), _vm._v(" "), _c('h4', [_vm._v("Loading")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:transition")])])]), _vm._v(" "), _c('h4', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加禁用背景颜色. "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1630",
      "target": "_blank"
    }
  }, [_vm._v("#1630")])])])]), _vm._v(" "), _c('h4', [_vm._v("XSwitch")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持使用 prop:prevent-default 来阻止自动设定值 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1606",
      "target": "_blank"
    }
  }, [_vm._v("#1606")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.4.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  readonly 值变化时重新渲染 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1593",
      "target": "_blank"
    }
  }, [_vm._v("#1593")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持通过 prop:default-selected-value 设置默认选中日期 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1576",
      "target": "_blank"
    }
  }, [_vm._v("#1576")])])])]), _vm._v(" "), _c('h4', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复json格式不正确引起的bug "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1584",
      "target": "_blank"
    }
  }, [_vm._v("#1584")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  popup-picker头部区域屏蔽滑动事件 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1596",
      "target": "_blank"
    }
  }, [_vm._v("#1596")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.4.0_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  统一弹窗头部样式，和 popup-picker 一致")])])]), _vm._v(" "), _c('h4', [_vm._v("Drawer")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件：侧边栏(beta)")])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  当 render-month 变化时重新渲染日历")])])]), _vm._v(" "), _c('h4', [_vm._v("Previewer")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  使用图片作为缩略图，防止先显示黑色区域")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  不再强制要求设置宽高 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1426",
      "target": "_blank"
    }
  }, [_vm._v("#1426")])])])]), _vm._v(" "), _c('h4', [_vm._v("Radio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 prop:selected-label-style 来支持定义选中项的文字样式")])])]), _vm._v(" "), _c('h4', [_vm._v("Range")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复一些情况下无法拖到最大值的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1556",
      "target": "_blank"
    }
  }, [_vm._v("#1556")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.3.8_COM")]), _vm._v(" "), _c('h4', [_vm._v("Checker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  当前选中 item 被 disabled 时清除值 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1479",
      "target": "_blank"
    }
  }, [_vm._v("#1479")])])])]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:disabled 禁用操作 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1254",
      "target": "_blank"
    }
  }, [_vm._v("#1254")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  不可见日期不可点击 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1564",
      "target": "_blank"
    }
  }, [_vm._v("#1564")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 iOS 低版本下 placeholder 无法显示的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1293",
      "target": "_blank"
    }
  }, [_vm._v("#1293")])])])]), _vm._v(" "), _c('h4', [_vm._v("Radio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:disabled 禁用操作 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1254",
      "target": "_blank"
    }
  }, [_vm._v("#1254")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 less 变量 "), _c('a', {
    attrs: {
      "href": "https://github.com/radio",
      "target": "_blank"
    }
  }, [_vm._v("@radio")]), _vm._v("-checked-icon-color "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/896",
      "target": "_blank"
    }
  }, [_vm._v("#896")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:title，方便自定义样式 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1389",
      "target": "_blank"
    }
  }, [_vm._v("#1389")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  是的，Datetime 可以作为插件直接调用了")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.3.7_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  可以使用 :show.sync 来控制控件显示 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1358",
      "target": "_blank"
    }
  }, [_vm._v("#1358")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复格式为 YYYY-MM 时的日期范围错误 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1528",
      "target": "_blank"
    }
  }, [_vm._v("#1528")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持通过 prop:hourList prop:minuteList 自定义小时和分钟列表")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  开始日期年份应该覆盖最小年份(minYear) "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1358",
      "target": "_blank"
    }
  }, [_vm._v("#1358")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:title")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:each-item")])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复默认值为 true 时遮罩没有显示的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1555",
      "target": "_blank"
    }
  }, [_vm._v("#1555")])])])]), _vm._v(" "), _c('h4', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复值类型 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1554",
      "target": "_blank"
    }
  }, [_vm._v("#1554")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.3.6_COM")]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持多个箭头样式变量")])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:title")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 prop:readonly")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 scroller 支持数字类型引入的 bug "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1406",
      "target": "_blank"
    }
  }, [_vm._v("#1406")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  render-function 参数 day => date（在 3.0 版本前不会影响目前使用）"), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1361",
      "target": "_blank"
    }
  }, [_vm._v("#1361")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 prop:readonly")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:icon")])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加方法 setBlur")])])]), _vm._v(" "), _c('h4', [_vm._v("Spinner")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:size "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1447",
      "target": "_blank"
    }
  }, [_vm._v("#1447")])])])]), _vm._v(" "), _c('h4', [_vm._v("String")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  可以直接引用 trim 代替原来的 stringTrim")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.3.5_COM")]), _vm._v(" "), _c('h4', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 slot:header "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1381",
      "target": "_blank"
    }
  }, [_vm._v("#1381")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持自定义每一天的 html 渲染 slot:each-day")])])]), _vm._v(" "), _c('h4', [_vm._v("Radio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持自定义渲染每一列 slot:each-item")])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加 slot:left")])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复重复渲染问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1458",
      "target": "_blank"
    }
  }, [_vm._v("#1458")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持设置 badge "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1513",
      "target": "_blank"
    }
  }, [_vm._v("#1513")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.3.4_COM")]), _vm._v(" "), _c('h4', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持遮罩点击事件 on-click-mask "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1496",
      "target": "_blank"
    }
  }, [_vm._v("#1496")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  初始化时不触发 on-change 事件")])])]), _vm._v(" "), _c('h4', [_vm._v("InlineLoading")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件")])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复只有两个轮播图且为 loop 时点击失效问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1484",
      "target": "_blank"
    }
  }, [_vm._v("#1484")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/unclay",
      "target": "_blank"
    }
  }, [_vm._v("@unclay")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.3.3_COM")]), _vm._v(" "), _c('h4', [_vm._v("Badge")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持没有指定文字时为 红点 样式")])])]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 slot:title")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 slot:popup-header")])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  默认 max-height 设为 100%，避免不设置高度时内容过长无法滚动")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:max-height")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  禁止遮罩层在手机上滚动 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1475",
      "target": "_blank"
    }
  }, [_vm._v("#1475")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/xiaobinhong1",
      "target": "_blank"
    }
  }, [_vm._v("@xiaobinhong1")])])])]), _vm._v(" "), _c('h4', [_vm._v("Selector")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  设置 placeholder 颜色. "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1465",
      "target": "_blank"
    }
  }, [_vm._v("#1465")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.3.2_COM")]), _vm._v(" "), _c('h4', [_vm._v("Checker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持在单选的情况下第二次点击时变成不选中当前项 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1468",
      "target": "_blank"
    }
  }, [_vm._v("#1468")])])])]), _vm._v(" "), _c('h4', [_vm._v("Group")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  gutter 属性允许为数字类型")])])]), _vm._v(" "), _c('h4', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 min 不存在的判断 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1459",
      "target": "_blank"
    }
  }, [_vm._v("#1459")])])])]), _vm._v(" "), _c('h4', [_vm._v("Date")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  无时间参数时返回字符串")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.3.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("Flow")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件")])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 render-function 生成的内容错误显示问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1409",
      "target": "_blank"
    }
  }, [_vm._v("#1409")])])])]), _vm._v(" "), _c('h4', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加获取对应文字方法 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1418",
      "target": "_blank"
    }
  }, [_vm._v("#1418")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复文字值显示")])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  为插件添加 text 方法方便调用")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 blur 方法 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1422",
      "target": "_blank"
    }
  }, [_vm._v("#1422")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.2_COM")]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:disabled 显示禁用样式")])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  当日期的替代文字为空字符串时，包含日期的 `span` 元素将不显示")])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复在某些情况下遮罩被错误关闭的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1312",
      "target": "_blank"
    }
  }, [_vm._v("#1312")])])])]), _vm._v(" "), _c('h4', [_vm._v("Range")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持动态设置 step "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1394",
      "target": "_blank"
    }
  }, [_vm._v("#1394")])])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  在 iOS 键盘上显示 search")])])]), _vm._v(" "), _c('h4', [_vm._v("Selector")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 label for 属性值缺失")])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持使用地址文字直接赋值(测试)")])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:dialog-style 覆写原有弹窗容器样式 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1282",
      "target": "_blank"
    }
  }, [_vm._v("#1282")])])])]), _vm._v(" "), _c('h4', [_vm._v("XHeader")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot:overwrite-left 方便覆写左侧部分")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  `value`为空字符串时，去掉 prop 类型检测 warning 信息，并禁用 `add` 和 `sub` 方法")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.1-rc.8_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  修改 prop:format 会触发重新渲染")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 label 宽度")])])]), _vm._v(" "), _c('h4', [_vm._v("Scroller")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  prop:prevent-default 默认设为 false")])])]), _vm._v(" "), _c('h4', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  当 `fillable` 为true时，修复数字第一位无法编辑的问题")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.1-rc.7_COM")]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 popup-picker 上个版本转换值的问题")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.1-rc.6_COM")]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 slot:inline-desc")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  display-format 支持 names 作为第二个参数")])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 popup 类名丢失问题")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:show-mask 隐藏遮罩")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:position 设定位置")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:width 设定左右位置时的宽度")])])]), _vm._v(" "), _c('h4', [_vm._v("Scroller")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持滚动到底部时触发事件 on-scroll-bottom")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  禁止点击事件触发，修复 pc 上触发两次的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Selector")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 placeholder 逻辑问题. "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1273",
      "target": "_blank"
    }
  }, [_vm._v("#1273")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持属性  display-format")])])]), _vm._v(" "), _c('h4', [_vm._v("XTextarea")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  标签上对齐")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持属性  prop:autosize 自动更新高度")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.1-rc.4_COM")]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持通过 prop:label-position 设置 label位置")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupRadio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件")])])]), _vm._v(" "), _c('h4', [_vm._v("Previewer")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  增加关闭事件 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1245",
      "target": "_blank"
    }
  }, [_vm._v("#1245")])])])]), _vm._v(" "), _c('h4', [_vm._v("Scroller")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持在滚回顶部时设置时间和缓动 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1240",
      "target": "_blank"
    }
  }, [_vm._v("#1240")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持 on-item-click 带上 index 参数")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持设置 label 宽度 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1186",
      "target": "_blank"
    }
  }, [_vm._v("#1186")])])])]), _vm._v(" "), _c('h4', [_vm._v("XTable")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.1-rc.3_COM")]), _vm._v(" "), _c('h4', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复当值设为空数组时不会重新渲染的问题. "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1230",
      "target": "_blank"
    }
  }, [_vm._v("#1230")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持设置 取消 和 确定 文字. "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1233",
      "target": "_blank"
    }
  }, [_vm._v("#1233")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.1-rc.2_COM")]), _vm._v(" "), _c('h4', [_vm._v("Badge")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复个位数字样式不正确 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1223",
      "target": "_blank"
    }
  }, [_vm._v("#1223")])])])]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  可以点击下个月日期并自动切换到下个月 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1192",
      "target": "_blank"
    }
  }, [_vm._v("#1192")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 start-date 和 end-date 变化后不重新渲染的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1219",
      "target": "_blank"
    }
  }, [_vm._v("#1219")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  如果初始化时获取不到宽度则直接使用视口宽度 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1188",
      "target": "_blank"
    }
  }, [_vm._v("#1188")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复初始化时 index > 0 不生效")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.1-rc.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("CellBox")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:border-intent, 用以不显示边框与左边间隙")])])]), _vm._v(" "), _c('h4', [_vm._v("CellFormPreview")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:border-intent, 用以不显示边框与左边间隙")])])]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:border-intent, 用以不显示边框与左边间隙")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:arrow-direction, 用以在折叠场景下动态更改方向")])])]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:check-disabled")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复错误的弹窗关闭类型 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1209",
      "target": "_blank"
    }
  }, [_vm._v("#1209")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.2.0_COM")]), _vm._v(" "), _c('h4', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  在使用 v-transfer-dom 的情况下不再处理 Safari 下的 z-index 问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 prop:content")])])]), _vm._v(" "), _c('h4', [_vm._v("ButtonTab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  更新 1px 边框")])])]), _vm._v(" "), _c('h4', [_vm._v("CellFormPreview")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件")])])]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:is-loading 显示加载图标，适用于异步加载数据的场景")])])]), _vm._v(" "), _c('h4', [_vm._v("DatetimeRange")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  优化宽度，避免日期栏和左边缘距离过近")])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  在 nextTick 回调渲染 picker 避免赋值报错 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1180",
      "target": "_blank"
    }
  }, [_vm._v("#1180")])])])]), _vm._v(" "), _c('h4', [_vm._v("Grid")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持定义列数")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  如果没有使用 icon 和 label，则直接隐藏 slot:icon 和 slot:label")])])]), _vm._v(" "), _c('h4', [_vm._v("Scroller")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 resize 事件没有移除导致切换页面报错 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1183",
      "target": "_blank"
    }
  }, [_vm._v("#1183")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复滚动情况下跳转页面报错 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1187",
      "target": "_blank"
    }
  }, [_vm._v("#1187")])])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  在 input 后触发 on-change 事件(否则此时 v-model 绑定的值和参数不一致)")])])]), _vm._v(" "), _c('h4', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复disabled时不能上下滚动问题")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复disabled时，安卓手机上不能触发点击事件的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  更新地区数据 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1101",
      "target": "_blank"
    }
  }, [_vm._v("#1101")])])])]), _vm._v(" "), _c('h4', [_vm._v("XIcon")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持传任意属性 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1147",
      "target": "_blank"
    }
  }, [_vm._v("#1147")])])])]), _vm._v(" "), _c('h4', [_vm._v("TransferDom")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持更简洁的引入方式：TransferDom")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  添加类名 v-transfer-dom")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.14_COM")]), _vm._v(" "), _c('h4', [_vm._v("Checker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  不可选项同样触发事件 on-item-click "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1144",
      "target": "_blank"
    }
  }, [_vm._v("#1144")])])])]), _vm._v(" "), _c('h4', [_vm._v("FormPreview")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 less 变量：form-preview-button-primary-color")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 prop:name 以方便函数调用 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1123",
      "target": "_blank"
    }
  }, [_vm._v("#1123")])])])]), _vm._v(" "), _c('h4', [_vm._v("Masker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持通过prop设置是否全屏显示")])])]), _vm._v(" "), _c('h4', [_vm._v("Selector")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复Selector不能设置name属性的问题"), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1133",
      "target": "_blank"
    }
  }, [_vm._v("#1133")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  Selector的value支持布尔型. "), _c('a', {
    attrs: {
      "href": "https://github.com/rbao",
      "target": "_blank"
    }
  }, [_vm._v("@rbao")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复来回滑动时左侧菜单可能会被滑出 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1139",
      "target": "_blank"
    }
  }, [_vm._v("#1139")])])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复初始化时 value 值为 true 无效的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1138",
      "target": "_blank"
    }
  }, [_vm._v("#1138")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.13_COM")]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 label 宽度不受控于 Group "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1110",
      "target": "_blank"
    }
  }, [_vm._v("#1110")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  取消文字使用灰色")])])]), _vm._v(" "), _c('h4', [_vm._v("Radio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复未响应数据变更的 bug "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1115",
      "target": "_blank"
    }
  }, [_vm._v("#1115")])])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 slot=right")])])]), _vm._v(" "), _c('h4', [_vm._v("Step")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 import 和 module.exports 混用的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 调用后没有设置webkitOverflowScrolling为touch")])])]), _vm._v(" "), _c('h4', [_vm._v("XHeader")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复不能设置返回文字为空 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1109",
      "target": "_blank"
    }
  }, [_vm._v("#1109")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/erguotou520",
      "target": "_blank"
    }
  }, [_vm._v("@erguotou520")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.12_COM")]), _vm._v(" "), _c('h4', [_vm._v("Marquee")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持异步数据渲染")])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  点击取消按钮后不再触发 on-change 事件")])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  简化市辖区数据")])])]), _vm._v(" "), _c('h4', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复primary类型按钮active时的background-color")])])]), _vm._v(" "), _c('h4', [_vm._v("XTextarea")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  点击x-textarea的counter时，主动触发focus事件")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.11_COM")]), _vm._v(" "), _c('h4', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  更加流畅的遮罩层动画")])])]), _vm._v(" "), _c('h4', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  作为插件使用时，每次都重置属性值")])])]), _vm._v(" "), _c('h4', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复插件代码里的值和事件监听器")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  以插件方式显示时强制重置数据")])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持格式化显示 prop:display-format "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1086",
      "target": "_blank"
    }
  }, [_vm._v("#1086")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/greedying",
      "target": "_blank"
    }
  }, [_vm._v("@greedying")])])])]), _vm._v(" "), _c('h4', [_vm._v("Loading")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  以插件形式使用时强制重置属性值")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  添加渐现动画")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  修复 Safari 下遮罩层渲染慢的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1083",
      "target": "_blank"
    }
  }, [_vm._v("#1083")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/sixiakun",
      "target": "_blank"
    }
  }, [_vm._v("@sixiakun")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  默认开启 transfer-dom，解决非 Safari 也会出现的 z-index 问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复遮罩禁用点击时错误设置 overflowScrolling 的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  更流畅的遮罩动画和弹窗动画")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  添加 dom 转移到 body 下的 demo")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  移除无用代码")])])]), _vm._v(" "), _c('h4', [_vm._v("XTextarea")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 on-focus on-blur 事件 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1082",
      "target": "_blank"
    }
  }, [_vm._v("#1082")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/zeusLeeJh",
      "target": "_blank"
    }
  }, [_vm._v("@zeusLeeJh")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.10_COM")]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持多个 less 变量. "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/896",
      "target": "_blank"
    }
  }, [_vm._v("#896")])])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 on-focus 事件")])])]), _vm._v(" "), _c('h4', [_vm._v("Timeline")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复图标位置")])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复警告图标样式")])])]), _vm._v(" "), _c('h4', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加禁用背景颜色. "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/896",
      "target": "_blank"
    }
  }, [_vm._v("#896")])])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 reset 函数 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/947",
      "target": "_blank"
    }
  }, [_vm._v("#947")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/erguotou520",
      "target": "_blank"
    }
  }, [_vm._v("@erguotou520")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.9_COM")]), _vm._v(" "), _c('h4', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修正 onHide 回调被错误调用 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1023",
      "target": "_blank"
    }
  }, [_vm._v("#1023")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/jsonviewer",
      "target": "_blank"
    }
  }, [_vm._v("@jsonviewer")])])])]), _vm._v(" "), _c('h4', [_vm._v("DatetimeRange")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/970",
      "target": "_blank"
    }
  }, [_vm._v("#970")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/327326724",
      "target": "_blank"
    }
  }, [_vm._v("@327326724")])])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  更流畅的遮罩层动画")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持透明背景")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持背影颜色变量 "), _c('a', {
    attrs: {
      "href": "https://github.com/popup",
      "target": "_blank"
    }
  }, [_vm._v("@popup")]), _vm._v("-background-color")])])]), _vm._v(" "), _c('h4', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复向右快速滑动时左侧菜单可能会被滑出")])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  插件调用时每次都重置为默认参数 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/870",
      "target": "_blank"
    }
  }, [_vm._v("#870")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/jsonviewer",
      "target": "_blank"
    }
  }, [_vm._v("@jsonviewer")])])])]), _vm._v(" "), _c('h4', [_vm._v("Date")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加日期范围生成函数")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  format 函数支持字符串参数")])])]), _vm._v(" "), _c('h4', [_vm._v("Number")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加数字范围生成函数")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.8_COM")]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  更新头部样式并新增 less 变量")])])]), _vm._v(" "), _c('h4', [_vm._v("Tabbar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持点击时切换图标")])])]), _vm._v(" "), _c('h4', [_vm._v("XHeader")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复过渡动画")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 返回文字 国际化")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持设置 placeholder 对齐方式")])])]), _vm._v(" "), _c('h4', [_vm._v("XTextarea")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持title属性")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.7_COM")]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持 PC 上鼠标选择 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1039",
      "target": "_blank"
    }
  }, [_vm._v("#1039")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/michael829",
      "target": "_blank"
    }
  }, [_vm._v("@michael829")])])])]), _vm._v(" "), _c('h4', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持 PC 上鼠标选择 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1039",
      "target": "_blank"
    }
  }, [_vm._v("#1039")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/michael829",
      "target": "_blank"
    }
  }, [_vm._v("@michael829")])])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持 PC 上鼠标选择 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1039",
      "target": "_blank"
    }
  }, [_vm._v("#1039")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/michael829",
      "target": "_blank"
    }
  }, [_vm._v("@michael829")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持根据值自定义显示格式")])])]), _vm._v(" "), _c('h4', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 Android 下按钮点击事件不触发问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1044",
      "target": "_blank"
    }
  }, [_vm._v("#1044")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/tangtaoit",
      "target": "_blank"
    }
  }, [_vm._v("@tangtaoit")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持定义 bar 宽度")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复初始化时没有 tab-item 时导致报错 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1038",
      "target": "_blank"
    }
  }, [_vm._v("#1038")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/liu2010y",
      "target": "_blank"
    }
  }, [_vm._v("@liu2010y")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  支持 PC 上鼠标选择 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1039",
      "target": "_blank"
    }
  }, [_vm._v("#1039")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/michael829",
      "target": "_blank"
    }
  }, [_vm._v("@michael829")])])])]), _vm._v(" "), _c('h4', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  在 nextTick 后触发 on-change 事件")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.6_COM")]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 Safari 上关闭第二个popup导致的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1015",
      "target": "_blank"
    }
  }, [_vm._v("#1015")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/think2011",
      "target": "_blank"
    }
  }, [_vm._v("@think2011")])])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复禁止样式被覆盖 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1016",
      "target": "_blank"
    }
  }, [_vm._v("#1016")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/LaiXuechao",
      "target": "_blank"
    }
  }, [_vm._v("@LaiXuechao")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.5_COM")]), _vm._v(" "), _c('h4', [_vm._v("InlineCalendar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 render-function 变化不重新渲染的问题")])])]), _vm._v(" "), _c('h4', [_vm._v("Md5")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  修复 import 和 module.exports 混用的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1007",
      "target": "_blank"
    }
  }, [_vm._v("#1007")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/zack24q",
      "target": "_blank"
    }
  }, [_vm._v("@zack24q")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.4_COM")]), _vm._v(" "), _c('h4', [_vm._v("Icon")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  不再内置类名 `icon-big`, 改用 prop:`is-msg` "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/988",
      "target": "_blank"
    }
  }, [_vm._v("#988")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/greedying",
      "target": "_blank"
    }
  }, [_vm._v("@greedying")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tabbar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 this.$slots 不存在 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/1000",
      "target": "_blank"
    }
  }, [_vm._v("#1000")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/asingingfish",
      "target": "_blank"
    }
  }, [_vm._v("@asingingfish")])])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持显示位置设置 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/973",
      "target": "_blank"
    }
  }, [_vm._v("#973")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/LaiXuechao",
      "target": "_blank"
    }
  }, [_vm._v("@LaiXuechao")])])])]), _vm._v(" "), _c('h4', [_vm._v("XIcon")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.3_COM")]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持字体变量 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/990",
      "target": "_blank"
    }
  }, [_vm._v("#990")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/wg5945",
      "target": "_blank"
    }
  }, [_vm._v("@wg5945")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 node 列表没有 forEach 方法 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/991",
      "target": "_blank"
    }
  }, [_vm._v("#991")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/howyhuang",
      "target": "_blank"
    }
  }, [_vm._v("@howyhuang")])])])]), _vm._v(" "), _c('h4', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复单独引入没有引入Loading组件时，样式缺失 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/986",
      "target": "_blank"
    }
  }, [_vm._v("#986")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/malaimoo",
      "target": "_blank"
    }
  }, [_vm._v("@malaimoo")])])])]), _vm._v(" "), _c('h4', [_vm._v("Ajax")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持通过 Vue.http 调用")])])]), _vm._v(" "), _c('h4', [_vm._v("Wechat")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持通过 Vue.wechat 调用")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.2_COM")]), _vm._v(" "), _c('h4', [_vm._v("Group")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 margin-top 等 less 变量")])])]), _vm._v(" "), _c('h4', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复部分机子不支持 for of 遍历")])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持更多 less 变量")])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复按钮文字颜色变量")])])]), _vm._v(" "), _c('h4', [_vm._v("XImg")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持延迟执行属性 delay")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.1-rc.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("CellBox")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件")])])]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 label 未正确设置 labelMarginRight "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/977",
      "target": "_blank"
    }
  }, [_vm._v("#977")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/wg5945",
      "target": "_blank"
    }
  }, [_vm._v("@wg5945")])])])]), _vm._v(" "), _c('h4', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 `overflow-scrolling` 设置逻辑遗漏问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/311",
      "target": "_blank"
    }
  }, [_vm._v("#311")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/linhaobin",
      "target": "_blank"
    }
  }, [_vm._v("@linhaobin")])])])]), _vm._v(" "), _c('h4', [_vm._v("Radio")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持左侧图标")])])]), _vm._v(" "), _c('h4', [_vm._v("Sticky")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复路由间有过渡动画导致顶部距离计算不准确的问题")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  设置 z-index 避免被覆盖 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/976",
      "target": "_blank"
    }
  }, [_vm._v("#976")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/olymk",
      "target": "_blank"
    }
  }, [_vm._v("@olymk")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tabbar")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复 less 变量 "), _c('a', {
    attrs: {
      "href": "https://github.com/tabbar",
      "target": "_blank"
    }
  }, [_vm._v("@tabbar")]), _vm._v("-text-active-color "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/982",
      "target": "_blank"
    }
  }, [_vm._v("#982")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/marsal1212",
      "target": "_blank"
    }
  }, [_vm._v("@marsal1212")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.0_COM")]), _vm._v(" "), _c('h4', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持数组定义菜单 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/950",
      "target": "_blank"
    }
  }, [_vm._v("#950")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/wuchuguang",
      "target": "_blank"
    }
  }, [_vm._v("@wuchuguang")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复`label`宽度没有受限于`group`设置")])])]), _vm._v(" "), _c('h4', [_vm._v("Icon")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  更新`WeUI`样式到最新版本")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  `type`参数由下划线变为中划线，组件内部做了兼容保证升级时无影响")])])]), _vm._v(" "), _c('h4', [_vm._v("Marquee")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件")])])]), _vm._v(" "), _c('h4', [_vm._v("Msg")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  新组件")])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  更新到`WeUI`最新代码")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  当`value`为空时，不显示清除按钮")])])]), _vm._v(" "), _c('h4', [_vm._v("ViewBox")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加`body-padding-top`及`body-padding-bottom`方便设定上下`padding`值")])])]), _vm._v(" "), _c('h4', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  更新到 `WeUI` 最新版本")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持 `prop:isLoading`")])])]), _vm._v(" "), _c('h4', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复`transition`绑定")])])]), _vm._v(" "), _c('h4', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  升级`WeUI`样式")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复`label`样式不受控于`group`设置")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持`align`属性")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.0-rc.51_COM")]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复`slots`判断问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/936",
      "target": "_blank"
    }
  }, [_vm._v("#936")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/zscumt123",
      "target": "_blank"
    }
  }, [_vm._v("@zscumt123")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.0-rc.50_COM")]), _vm._v(" "), _c('h4', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复`on-change`事件没有触发 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/934",
      "target": "_blank"
    }
  }, [_vm._v("#934")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/howyhuang",
      "target": "_blank"
    }
  }, [_vm._v("@howyhuang")])])])]), _vm._v(" "), _c('h4', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  `swipeout`组件`beta`版本")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.0-rc.49_COM")]), _vm._v(" "), _c('h4', [_vm._v("FormPreview")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复出现滚动条 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/920",
      "target": "_blank"
    }
  }, [_vm._v("#920")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/asingingfish",
      "target": "_blank"
    }
  }, [_vm._v("@asingingfish")])])])]), _vm._v(" "), _c('h4', [_vm._v("XAddress")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持`value-text-align` "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/921",
      "target": "_blank"
    }
  }, [_vm._v("#921")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/linhaobin",
      "target": "_blank"
    }
  }, [_vm._v("@linhaobin")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复`label`样式不受控于`group`属性的bug")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持`slot=restricted-label` "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/918",
      "target": "_blank"
    }
  }, [_vm._v("#918")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/zqyadam",
      "target": "_blank"
    }
  }, [_vm._v("@zqyadam")])])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.0-rc.48_COM")]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持`debounce` "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/715",
      "target": "_blank"
    }
  }, [_vm._v("#715")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/YYmmlin",
      "target": "_blank"
    }
  }, [_vm._v("@YYmmlin")])])])]), _vm._v(" "), _c('h4', [_vm._v("Debounce")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加`debounce`工具")])])]), _vm._v(" "), _c('h4', [_vm._v("Throttle")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加`throttle`工具")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.0-rc.47_COM")]), _vm._v(" "), _c('h4', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  修复内容多时的箭头位置 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/715",
      "target": "_blank"
    }
  }, [_vm._v("#715")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/greedying",
      "target": "_blank"
    }
  }, [_vm._v("@greedying ")])])])]), _vm._v(" "), _c('h4', [_vm._v("Qrcode")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持渲染类型为图片 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/900",
      "target": "_blank"
    }
  }, [_vm._v("#900")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/keepgoingwm",
      "target": "_blank"
    }
  }, [_vm._v("@keepgoingwm")])])])]), _vm._v(" "), _c('h4', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  删除无用代码")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复`取消`按钮在非`fixed`情况下没有出现的问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/excitedcat",
      "target": "_blank"
    }
  }, [_vm._v("@excitedcat")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复页面上多个实例时，`label id`冲突")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.1.0-rc.46_COM")]), _vm._v(" "), _c('h4', [_vm._v("ButtonTab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加更多`less`变量 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/896",
      "target": "_blank"
    }
  }, [_vm._v("#896")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/erguotou520",
      "target": "_blank"
    }
  }, [_vm._v("@erguotou520")])])])]), _vm._v(" "), _c('h4', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持配置`取消`和`确定`的文字颜色 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/715",
      "target": "_blank"
    }
  }, [_vm._v("#715")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/greedying",
      "target": "_blank"
    }
  }, [_vm._v("@greedying")])])])]), _vm._v(" "), _c('h4', [_vm._v("Tab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持设置 `bar-active-color` "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/715",
      "target": "_blank"
    }
  }, [_vm._v("#715")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/greedying",
      "target": "_blank"
    }
  }, [_vm._v("@greedying")])])])]), _vm._v(" "), _c('h4', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加`less`变量 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/896",
      "target": "_blank"
    }
  }, [_vm._v("#896")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/erguotou520",
      "target": "_blank"
    }
  }, [_vm._v("@erguotou520")])])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加`slot=label`自定义label部分内容 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/895",
      "target": "_blank"
    }
  }, [_vm._v("#895")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/erguotou520",
      "target": "_blank"
    }
  }, [_vm._v("@erguotou520")])])])]), _vm._v(" "), _c('h4', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  使用`svg`代替 `+` `-` 字符")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持圆形按钮样式")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.0.14_COM")]), _vm._v(" "), _c('h4', [_vm._v("Grid")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加`grid`九宫格组件")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.0.1_COM")]), _vm._v(" "), _c('h4', [_vm._v("Loading")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  i18n 无配置")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复type未定义的问题")])])]), _vm._v(" "), _c('h3', [_vm._v("v2.0.0_COM")]), _vm._v(" "), _c('h4', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  更新到 vue"), _c('a', {
    attrs: {
      "href": "https://github.com/2",
      "target": "_blank"
    }
  }, [_vm._v("@2")]), _vm._v(".0，使用 `v-model` 而不是`:show.sync`进行显示属性绑定")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 `close-on-clicking-mask`, 适用于强制选择的场景")])])]), _vm._v(" "), _c('h4', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  使用 `v-model` 而不是`:show.sync`进行显示属性绑定")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-todo"
  }, [_vm._v("todo")]), _vm._v("  修复动画")])])]), _vm._v(" "), _c('h4', [_vm._v("ButtonTab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  去除 Android 下点击可能出现的蓝色边框")])])]), _vm._v(" "), _c('h4', [_vm._v("Checker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  支持Object类型的值 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/705",
      "target": "_blank"
    }
  }, [_vm._v("#705")])])])]), _vm._v(" "), _c('h4', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  默认不显示错误，你可以监听on-error事件结合slot进行处理和显示")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加插槽 footer、after-title")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  如果已经达到max上限，没有选中的选项将不能选择，因此不再和之前版本一样会出现最多可选max个的error信息")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  默认 required 值为false, 与html规范一致")])])]), _vm._v(" "), _c('h4', [_vm._v("ColorPicker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-deprecated"
  }, [_vm._v("deprecated")]), _vm._v("  废弃，当前版本后不再继续维护")])])]), _vm._v(" "), _c('h4', [_vm._v("Countdown")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-deprecated"
  }, [_vm._v("deprecated")]), _vm._v("  下一版本开始不再维护")])])]), _vm._v(" "), _c('h4', [_vm._v("Countup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 prop:`start`, 现在你可以手动开始计数了")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  更新依赖`countup`为`countup.js`")])])]), _vm._v(" "), _c('h4', [_vm._v("FormPreview")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加`form-preview`组件")])])]), _vm._v(" "), _c('h4', [_vm._v("LoadMore")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  增加`load-more`组件")])])]), _vm._v(" "), _c('h4', [_vm._v("Popover")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-todo"
  }, [_vm._v("todo")]), _vm._v("  当切换i18n语言时，位置不正确")])])]), _vm._v(" "), _c('h4', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  使用 `v-model` 而不是`:show.sync`进行显示属性绑定")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  默认不显示遮罩")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 isShowMask 属性")])])]), _vm._v(" "), _c('h4', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加 `novalidate` 及 `iconType` 可以禁用组件验证，手动显示 error 或者 success 样式")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  `is-type` 支持传入函数")])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  受限于vue2不能动态设置type，目前`type`支持 text password number email")])])]), _vm._v(" "), _c('h4', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  fillable 值默认为false, 稍微保护一下不小心商城的后端接口没有做好数据校验的用户，导致用户粘贴负数还提交正确")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b2d7855e", module.exports)
  }
}

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2002);

/***/ })

});


// WEBPACK FOOTER //
// 595.135ab539.js